import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'ebazzari.chat_disclaimer.heard'

export default class extends Controller {
  static targets = ['audio', 'fallback']

  connect () {
    if (this.hasAudioTarget) {
      this.onEnded = () => this.showFallback()
      this.audioTarget.addEventListener('ended', this.onEnded)
    }

    if (this.alreadyHeard()) {
      this.showFallback()
      return
    }

    this.tryAutoplay()
  }

  disconnect () {
    if (this.hasAudioTarget && this.onEnded) {
      this.audioTarget.removeEventListener('ended', this.onEnded)
    }
  }

  play (event) {
    event?.preventDefault()
    this.playAudio()
  }

  close (event) {
    event?.preventDefault()
    this.hideFallback()
  }

  tryAutoplay () {
    if (!this.hasAudioTarget) return

    const playPromise = this.audioTarget.play()
    if (!playPromise) return

    playPromise
      .then(() => {
        this.markHeard()
      })
      .catch(() => {
        this.showFallback()
      })
  }

  playAudio () {
    if (!this.hasAudioTarget) return

    this.hideFallback()
    this.audioTarget.currentTime = 0
    this.audioTarget
      .play()
      .then(() => {
        this.markHeard()
      })
      .catch(() => {
        this.showFallback()
      })
  }

  showFallback () {
    if (this.hasFallbackTarget) {
      this.fallbackTarget.classList.remove('hidden')
    }
  }

  hideFallback () {
    if (this.hasFallbackTarget) {
      this.fallbackTarget.classList.add('hidden')
    }
  }

  alreadyHeard () {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1'
    } catch {
      return false
    }
  }

  markHeard () {
    try {
      localStorage.setItem(STORAGE_KEY, '1')
    } catch {
      // Private browsing or storage blocked, so skip persistence.
    }
  }
}
